import { useSelector } from 'react-redux';
import { convertCurrency, getCurrencySymbol } from '../../util/currencyConversion';

export const useCurrencyFormatter = (userRole) => {
  const selectedCurrency = useSelector(state => state.currency.selectedCurrency);
  const fxRatesFromStore = useSelector(state => state.currency.fxRates);
  const fxRates = fxRatesFromStore || { AED: 3.6725, EUR: 0.92 };

  /**
   * Format a numeric amount into the user's selected currency.
   * @param {number} val - The amount in major units (e.g. 70 for $70)
   * @param {string} [sourceCurrency] - The currency the amount is already in.
   *   Defaults to 'USD' for backward compatibility.
   */
  const formatAmount = (val, sourceCurrency = 'USD') => {
    if (val == null || isNaN(val)) return '';
    
    const isNegative = val < 0;
    const absVal = Math.abs(val);

    const conv = convertCurrency(absVal, sourceCurrency, selectedCurrency, fxRates);
    const amountVal = conv.amount.toFixed(2);
    let formatted = '';

    if (conv.currency === 'USD') {
      formatted = `$${amountVal}`;
    } else if (conv.currency === 'AED') {
      formatted = `AED ${amountVal}`;
    } else {
      formatted = `${getCurrencySymbol(conv.currency)}${amountVal}`;
    }

    return isNegative ? `-${formatted}` : formatted;
  };

  return { formatAmount, selectedCurrency, fxRates };
};

